import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import DiabetesRiskCalc from '../CalculatorCodes/DiabetesRiskCode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import restrictions from "../../../JSONS/calculator_res.json"

const DiabetesCalculator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const [Height,setHeight] = useState("")
    const [PastHeight,setPastHeight] = useState(false)
    const [Weight,setWeight] = useState("")
    const [PastWeight,setPastWeight] = useState(false)
    const [AbdominalPerimeter,setAbdominalPerimeter] = useState("")
    const [PastAbs,setPastAbs] = useState(false)
    const [PMH,setPMH] = useState([])
    const [FMH,setFMH] = useState([])

    const [Exercise, setExercise] = useState("");
    const [FruitsOrVegetables, setFruitsOrVegetables] = useState("");
    const [HipertensionMeds, setHipertensionMeds] = useState("");
    const [Hyperglycemia, setHyperglycemia] = useState("");
    const [FamilyMember, setFamilyMember] = useState("");
    const [Parents, setParents] = useState(0);
    const [Siblings, setSiblings] = useState(0);
    const [Children, setChildren] = useState(0);
    const [Cousins, setCousins] = useState(0);
    const [UnclesAndAunts, setUnclesAndAunts] = useState(0);
    const [Grandparents, setGrandparents] = useState(0);
    const [CloseFamilyDiabetes, setCloseFamilyDiabetes] = useState(0);
    const [DistantFamilyDiabetes, setDistantFamilyDiabetes] = useState(0);

    const [RiskPoints, setRiskPoints] = useState(0);
    const [RiskNum, setRiskNum] = useState(0);
    const [RiskCategory, setRiskCategory] = useState("");
    const [FirstPartOfSurveyDone, setFirstPartOfSurveyDone] = useState(0)
    const [Calculated, setCalculated] = useState(false)
    const [PageStart, setPageStart] = useState(true)
    const [TaskDone, setTaskDone] = useState(false)
    const [Sendoff, setSendoff] = useState(false)

    const [validation, setvalidation] = useState({
      "Weight": "empty",
      "Height": "empty",
      "AbdominalPerimeter" : "empty"
    });
    const [validation2, setvalidation2] = useState({
      "Q1": "valid",
      "Q2": "valid",
      "Q3": "valid",
      "Q4" : "valid",
      "Q5" : "valid",
      "Tiles" : "valid"
    });

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false

    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;

    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();
    
        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = DoB ? AgeCalc() : 0

    useEffect(() => {
        if(!opening || Age < restrictions["diabetes"].min_age || Age > restrictions["diabetes"].max_age) {
        window.scrollTo(0, 0);
        Navigate("/perfil-de-usuario/calculadora-de-salud")
        }
    }, [opening,Navigate,Age]);

    useEffect(() =>{
        if (Parents || Siblings || Children) {
            setCloseFamilyDiabetes(1);
        }
        else {
            setCloseFamilyDiabetes(0);
        }
    }, [Parents, Children, Siblings]
    )

    useEffect(() =>{
        if (Grandparents || UnclesAndAunts || Cousins) {
            setDistantFamilyDiabetes(1);
        }
        else {
            setDistantFamilyDiabetes(0);
        }
    }, [Grandparents, UnclesAndAunts, Cousins]
    )

    const getIMC = useCallback((height = Height, weight = Weight) => {
      let imc = parseInt(weight)/(parseInt(height)/100)**2
      let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
      let which = 0
      let ideal = [0,0]
      if(imc < 18.5) {
          which = 0
      } else if(imc < 25 & imc >= 18.5) {
          which = 1
      } else if(imc < 30 & imc >= 25) {
          which = 2
      } else if(imc < 35 & imc >= 30) {
          which = 3
      } else if(imc < 40 & imc >= 35) {
          which = 4
      } else {
          which = 5
      }
      ideal[0] = Math.round(((height/100)**2) * 18.5)
      ideal[1] = Math.round(((height/100)**2) * 25)
      return [imc, cats[which], which, ideal]
    }, [Height,Weight])
  
    function FamilyMemberChange(answer) {
      if (answer !== "NO"){
          setFamilyMember(1)
      }
      if (answer !== "YES"){
          setFamilyMember(0)
          setParents(0)
          setChildren(0)
          setSiblings(0)
          setGrandparents(0)
          setUnclesAndAunts(0)
          setCousins(0)
      }
    }
  
    function ParentsChange() {
      let tmp = document.getElementById("ParentsTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setParents(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setParents(1);
      }
    }
  
    function SiblingsChange() {
      let tmp = document.getElementById("SiblingsTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setSiblings(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setSiblings(1);
      }
    }
  
    function ChildrenChange() {
      let tmp = document.getElementById("ChildrenTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setChildren(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setChildren(1);
      }
    }
  
    function GrandparentsChange() {
      let tmp = document.getElementById("GrandparentsTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setGrandparents(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setGrandparents(1);
      }
    }
  
    function UnclesAndAuntsChange() {
      let tmp = document.getElementById("UnclesAndAuntsTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setUnclesAndAunts(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setUnclesAndAunts(1);
      }
    }
  
    function CousinsChange() {
      let tmp = document.getElementById("CousinsTile");
      if (tmp.className.includes("DiabetesRiskCalculatorPart2FamilyMemberActive")) {
          tmp.className = tmp.className.replace(" DiabetesRiskCalculatorPart2FamilyMemberActive","");
          setCousins(0);
      }
      else {
          tmp.className += " DiabetesRiskCalculatorPart2FamilyMemberActive";
          setCousins(1);
      }
    }
  
    const handleChange = (value, setValue) => {
      const result = value.replace(/\D/g, '');
      setValue(result.slice(0, 3));
    };

    function toggleDescription(type,num="") {
      let tmp = document.getElementById("More"+num)
      let tmp2 = document.getElementById("Less"+num)
      if(type === "Less") {
          tmp.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
          tmp2.className = tmp2.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
      } else {
          tmp.className = tmp.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
          tmp2.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
      }
  }

    function GoBack() {
      setExercise("");
      setFruitsOrVegetables("");
      setHipertensionMeds("");
      setHyperglycemia("");
      setFamilyMember("");
      setParents(0);
      setChildren(0);
      setSiblings(0);
      setGrandparents(0);
      setUnclesAndAunts(0);
      setCousins(0);
      setFirstPartOfSurveyDone(0);
      setvalidation2({
        "Q1": "valid",
        "Q2": "valid",
        "Q3": "valid",
        "Q4" : "valid",
        "Q5" : "valid",
        "Tiles" : "valid"
      })
      document.body.scrollTop = 0; 
      document.documentElement.scrollTop = 0;
    }

    function HandleSubmitFirstPart() {
      let isWeightValid = Weight.trim() === "" ? "invalid" : "valid";
      let isHeightValid = Height.trim() === "" ? "invalid" : "valid";
      let isAbdominalPerimeterValid = AbdominalPerimeter.trim() === "" ? "invalid" : "valid";
  
      if(Weight < 2 || Weight > 650) {
          isWeightValid = "invalid"
        }
      if(Height < 54 || Height > 272) {
          isHeightValid = "invalid"
      }
  
      if(AbdominalPerimeter < 30 || AbdominalPerimeter > 300) {
          isAbdominalPerimeterValid = "invalid"
      }
  
      setvalidation({
          "Weight": isWeightValid,
          "Height": isHeightValid,
          "AbdominalPerimeter": isAbdominalPerimeterValid
      });
  
      if (isWeightValid === "valid" && isHeightValid === "valid" && isAbdominalPerimeterValid === "valid"){
          document.body.scrollTop = 0; 
          document.documentElement.scrollTop = 0;
          setFirstPartOfSurveyDone(true);
      }
    }

    function CalculateDiabetesRisk() {
      let answers = [Exercise,FruitsOrVegetables,HipertensionMeds,Hyperglycemia,FamilyMember]
      let ideal = ["valid","valid","valid","valid","valid","valid"]
      for(let i=0; i<answers.length; i++) {
          if(answers[i].length === 0) {
              ideal[i] = "invalid"
          }
      }
      if(ideal[4] === "valid" && FamilyMember === 1) {
          if(Parents+Siblings+Children+Cousins+UnclesAndAunts+Grandparents === 0) {
              ideal[5] = "invalid"
          }
      } 

      setvalidation2({
          "Q1": ideal[0],
          "Q2": ideal[1],
          "Q3": ideal[2],
          "Q4" : ideal[3],
          "Q5" : ideal[4],
          "Tiles" : ideal[5]
      })
      
      if(!ideal.includes('invalid')) {
        let imc = getIMC()
        
        let riskCalc = DiabetesRiskCalc(
          Gender === 1 ? "M" : "F",
          Age,
          imc,
          AbdominalPerimeter,
          Exercise,
          FruitsOrVegetables,
          HipertensionMeds,
          Hyperglycemia,
          CloseFamilyDiabetes,
          DistantFamilyDiabetes)
        setRiskPoints(riskCalc);
        if(riskCalc < 7) {
            setRiskCategory("Muy Bajo")
            setRiskNum(0)
        } else if(riskCalc < 12) {
            setRiskCategory("Bajo")
            setRiskNum(1)
        } else if(riskCalc < 15) {
            setRiskCategory("Moderado")
            setRiskNum(2)
        } else if(riskCalc < 20) {
            setRiskCategory("Alto")
            setRiskNum(3)
        } else {
            setRiskCategory("Muy Alto")
            setRiskNum(4)
        }
        setSendoff(true)
      }
    }

    const requestGetPatient = useCallback(async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
              <div className="FullAlertUpTitle">Cargando información de perfil...</div>
              <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let parameters = {
            rut: decodedToken.rut
        }
    
        let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters)
        };

      let parameters2 = {
        rut: decodedToken.rut,
        within: [51,52,56]
      }
  
      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters2)
      };

      let tmp = validation
  
      try{
        let resp = await fetch("https://ymc-doc-api.azurewebsites.net/getprofiledata", requestOptions)
        if (resp.status !== 200){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error obteniendo los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
        }
        let data = await resp.json();
        
        if(data.pmh) { 
            setPMH(data.pmh)
        }
        if(data.fmh) { 
            setFMH(data.fmh)
        }

        let hasParams = true
        let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
        if (resp2.status !== 200){
            if(resp2.status !== 500) {
              MySwal.fire({
                  icon: "error",
                  title: "Ocurrió un error al subir los datos",
                  text: "Por favor inténtelo más tarde",
                  showConfirmButton: true
              });
              return false;
            } else {
              hasParams = false
            }
        }
        let data2 = await resp2.json();
        
        if(hasParams) {
            if(data2.params["51"]) {
              setWeight(data2.params["51"][1])
              setPastWeight(true)
              tmp["Weight"] = "valid"
            }
            if(data2.params["52"]) {
              setHeight(data2.params["52"][1])
              setPastHeight(true)
              tmp["Height"] = "valid"
            }
            if(data2.params["51"] && data2.params["52"]) {
              getIMC(data2.params["52"][1],data2.params["51"][1])
            }
            if(data2.params["56"]) {
              setAbdominalPerimeter(data2.params["56"][1])
              setPastAbs(true)
              tmp["AbdominalPerimeter"] = "valid"
            }
        }

        MySwal.close();
        setTaskDone(true);
      }
      catch(error){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error procesando la búsqueda",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
      }
    },[MySwal,decodedToken,getIMC,validation]);

    useEffect(() => {
        if(PageStart) {
          requestGetPatient()
          setPageStart(false)
        }
    }, [PageStart, requestGetPatient])

    const uploadDiabetes = useCallback( async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Calculando...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })
    
        var params = {
            rut: decodedToken.rut,
            gender: Gender,
            age: Age,
            hypertension: HipertensionMeds === 1 ? true : false,
            diabetes_fam: CloseFamilyDiabetes === 1 || DistantFamilyDiabetes === 1 ? true : false,
            height: Height,
            weight: Weight,
            abs: AbdominalPerimeter,
            YN: [Exercise,
            FruitsOrVegetables,
            HipertensionMeds,
            Hyperglycemia,
            CloseFamilyDiabetes,
            DistantFamilyDiabetes],
            diabetes_points: RiskPoints,
            diabetes_risk: RiskNum,
        };
  
        let finalParamids = [
          !PastWeight ? 51 : false,
          !PastHeight ? 52 : false,
          !PastAbs ? 56 : false,
        ].filter(med => med !== false);
        let finalResults = [
          !PastWeight ? Weight : false,
          !PastHeight ? Height : false,
          !PastAbs ? AbdominalPerimeter : false,
        ].filter(med => med !== false);
  
        let Dated = new Date()
    
        let params2 = {
          rut: decodedToken.rut,
          sex: Gender === 1 ? "M" : "F",
          ans: finalResults,
          ids: finalParamids,
          diabetesFR: RiskNum,
          date: Dated
        }

        if(!PMH.includes("AP003") && HipertensionMeds === 0) {
            let newpmh = PMH.push("AP003")
            params2['pmh'] = newpmh
        } else if(PMH.includes("AP003") && HipertensionMeds === 1) {
            let newpmh = PMH.filter(pmh => pmh !== "AP003")
            params2['pmh'] = newpmh
        }

        if(!FMH.includes("AF007") && (CloseFamilyDiabetes === 1 || DistantFamilyDiabetes === 1)) {
            let newfmh = FMH.push("AF007")
            params2['fmh'] = newfmh
        } else if(FMH.includes("AF007") && (CloseFamilyDiabetes === 1 || DistantFamilyDiabetes === 1)) {
            let newfmh = FMH.filter(fmh => fmh !== "AF007")
            params2['fmh'] = newfmh
        }
      
        let requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params)
        };
  
        let requestOptions2 = {
          method: 'POST',
          redirect: 'follow',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params2)
        };
    
        try{
          
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/userdiabetes", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
                });
                return false;
            }
    
            const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
            if (resp2.status !== 200){
              MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
              });
              return false;
            }

            setCalculated(true)
            document.body.scrollTop = 0; 
            document.documentElement.scrollTop = 0;
            MySwal.close();
        }
        catch(error){
            //console.log("there has been an error login in")
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false
        }
    },[AbdominalPerimeter,Age,Gender,Height,MySwal,PastAbs,PastHeight,PastWeight,RiskNum,RiskPoints,Weight,decodedToken,CloseFamilyDiabetes,DistantFamilyDiabetes,Exercise,FruitsOrVegetables,HipertensionMeds,Hyperglycemia,PMH,FMH])

    useEffect(() => {
        if(Sendoff) {
            uploadDiabetes()
            setSendoff(false)
        }
    }, [Sendoff, uploadDiabetes]);

    function toggleAdditional2(id) {
        let tmp = document.getElementById(id)
        if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
          tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
        } else {
          tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
        }
    }

    return (
        <div className='UserProfileFull'>
          <div className='UserProfileInnerDiv'>
            <div className='UserProfileInnerDivCalculatorWhiteBlock'>
            { !FirstPartOfSurveyDone && TaskDone ?
            <>
            <div className='UserWelcomeBlockPageWideFlex'>
                <div className='UserWelcomeBlockPageWideSideL'>
                    <div className='UserWelcomeBlockPage1TitleFlex'>
                        <div className='UserWelcomeBlockPage1Title'>Calcula tu riesgo de diabetes&ensp;</div>
                        <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>
                    </div>
                    <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">El test de Findrisc es un cuestionario permite detectar el riesgo de desarrollar diabetes en los próximos 10 años.</div>
                    <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/DiabetesSurveyImage2.png" />
                    <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>1</span> de 2</div>
                    <div className='UserWelcomeIntroPageCounterLineStart'>
                        <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                        <div className='UserWelcomeIntroPageCounterLine'></div>
                    </div>
                </div>
                <div className='UserWelcomeBlockPageWideSideR'>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockTitle">Completa los datos faltantes para calcular tu riesgo a desarrollar diabetes en los próximos 10 años</div>
                    <div className="UserWelcomeBlockYNQuestion">Antecedentes precompletados</div>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompleted">
                        • Edad: {Age}<br/>
                        • Sexo al Nacer: {Gender === 1 ? "Hombre" : "Mujer"}<br/>
                        {PastHeight ?
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Estatura: {Height}</div>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastHeight(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                            </div>
                        </div>
                        : null}
                        {PastWeight ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Peso: {Weight} Kg</div>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastWeight(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                            </div>
                        </div>
                        : null}
                        {PastAbs ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Perímetro Abdominal: {AbdominalPerimeter}</div>
                            <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastAbs(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                            </div>
                        </div>
                        : null}
                    </div>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestionFlex">
                        { PastWeight ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Weight"] === "invalid" ? "red" : validation["Weight"] === "valid" ? "#8BC53F" : null}}>Ingresa tu peso </div>
                            <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Weight}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Weight"] === "invalid" ? "red solid 1px" : validation["Weight"] === "valid" ? "#8BC53F solid 1px" : Weight.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Weight"] === "invalid" ? "#FFFAEA" : validation["Weight"] === "valid" || Weight.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCWeight"
                                onChange={(e) => handleChange(e.target.value,setWeight)}/>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">kg</div>
                            </div>
                            {validation["Weight"] === "invalid" ?
                                <div className='WeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                            : null }
                        </div>
        }
                        { PastHeight ?
                            null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Height"] === "invalid" ? "red" : validation["Height"] === "valid" ? "#8BC53F" : null}}>Ingresa tu altura </div>
                            <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                            <input
                                value={Height}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation["Height"] === "invalid" ? "red solid 1px" : validation["Height"] === "valid" ? "#8BC53F solid 1px" : Height.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Height"] === "invalid" ? "#FFFAEA" : validation["Height"] === "valid" || Height.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCHeight"
                                onChange={(e) => handleChange(e.target.value,setHeight)}/>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                            </div>
                            {validation["Height"] === "invalid" ?
                                <div className='HeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                            : null }
                        </div>
        }
                        { PastAbs ?
                            null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                            <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["AbdominalPerimeter"] === "invalid" ? "red" : validation["AbdominalPerimeter"] === "valid" ? "#8BC53F" : null}}>Perímetro abdominal</div>
                            <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                                <input
                                    value={AbdominalPerimeter}
                                    className="SignInInnerBoxInputTile"
                                    style={{ borderBottom: validation["AbdominalPerimeter"] === "invalid" ? "red solid 1px" : validation["AbdominalPerimeter"] === "valid" ? "#8BC53F solid 1px" : AbdominalPerimeter.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["AbdominalPerimeter"] === "invalid" ? "#FFFAEA" : validation["AbdominalPerimeter"] === "valid" || AbdominalPerimeter.length === 0 ? "#FBFFFF" : "#F2F2FF"}}
                                    id="YMCAbdominalPerimeter"
                                    onChange={(e) => handleChange(e.target.value,setAbdominalPerimeter)}/>
                                <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                            </div>
                            <div className='UserProfileDiabetesWhiteBoxAbdominalPerimeterExplanation'>* Usa de referencia el punto medio entre la ultima costilla inferior hasta el hueso de la cadera.</div>
                            {validation["AbdominalPerimeter"] === "invalid" ?
                                <div className='WeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                            : null }
                        </div>
                    }
                    </div>
                </div>
            </div>
            <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => HandleSubmitFirstPart()}>Comenzar<div className='triangle'><i className='innerarrowWhite'></i></div></div>
            </>
          : FirstPartOfSurveyDone && !Calculated ?
          <>
          <div className='UserWelcomeBlockPageWideFlex'>
            <div className='UserWelcomeBlockPageWideSideL'>
                <div className='UserWelcomeBlockPage1TitleFlex'>
                    <div className='UserWelcomeBlockPage1Title'>Calcula tu riesgo de diabetes&ensp;</div>
                    <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>
                </div>
                <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">El test de Findrisc es un cuestionario permite detectar el riesgo de desarrollar diabetes en los próximos 10 años.</div>
                <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/DiabetesSurveyImage2.png" />
                <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>2</span> de 2</div>
                <div className='UserWelcomeIntroPageCounterLineStart'>
                    <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                    <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                </div>
            </div>
            <div className='UserWelcomeBlockPageWideSideR'>
                <div className='UserProfileDiabetesWhiteBoxPart1'>
                    <div className='DiabetesRiskCalculatorRightSideSurveyQ1'>
                        <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className="UserWelcomeBlockYNQuestion DiabetesRiskCalculatorRightSideSurveyPart2Question" style={{color: validation2["Q1"] === "invalid" ? "red" : Exercise.length !== 0 ? "#8BC53F" : null}}>6. Realiza ejercicio habitualmente</div>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ1Answers">
                                <div className={Exercise === 0 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} id="ExerciseTile" style={{borderBottom: validation2["Q1"] === "invalid" ? "red solid 1px" : Exercise.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Exercise === 0 ? "#F2F2FF" : validation2["Q1"] === "invalid" ? "#FFFAEA" : "white"}} onClick={() => setExercise(0)}>
                                    Si 
                                </div>
                                <div className={Exercise === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} id="NoExerciseTile" style={{borderBottom: validation2["Q1"] === "invalid" ? "red solid 1px" : Exercise.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Exercise === 1 ? "#F2F2FF" : validation2["Q1"] === "invalid" ? "#FFFAEA" : "white"}} onClick={() => setExercise(1)}>
                                    No
                                </div>
                            </div>
                        </div>
                        {validation2["Q1"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja una opción en la pregunta anterior</div>
                        : null }
                    </div>
                    <div className='DiabetesRiskCalculatorRightSideSurveyQ1'>
                        <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className="UserWelcomeBlockYNQuestion DiabetesRiskCalculatorRightSideSurveyPart2Question" style={{color: validation2["Q2"] === "invalid" ? "red" : FruitsOrVegetables.length !== 0 ? "#8BC53F" : null}}>7. ¿Come a diario frutas o verduras?</div>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ1Answers">
                                <div className={FruitsOrVegetables === 0 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q2"] === "invalid" ? "red solid 1px" : FruitsOrVegetables.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: FruitsOrVegetables === 0 ? "#F2F2FF" : validation2["Q2"] === "invalid" ? "#FFFAEA" : "white"}} id="FruitsOrVegetablesTile" onClick={() => setFruitsOrVegetables(0)}>
                                    Si 
                                </div>
                                <div className={FruitsOrVegetables === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q2"] === "invalid" ? "red solid 1px" : FruitsOrVegetables.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: FruitsOrVegetables === 1 ? "#F2F2FF" : validation2["Q2"] === "invalid" ? "#FFFAEA" : "white"}} id="NoFruitsOrVegetablesTile" onClick={() => setFruitsOrVegetables(1)}>
                                    No
                                </div>
                            </div>
                        </div>
                        {validation2["Q2"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja una opción en la pregunta anterior</div>
                        : null }
                    </div>
                    <div className='DiabetesRiskCalculatorRightSideSurveyQ1'>
                        <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className="UserWelcomeBlockYNQuestion DiabetesRiskCalculatorRightSideSurveyPart2Question" style={{color: validation2["Q3"] === "invalid" ? "red" : HipertensionMeds.length !== 0 ? "#8BC53F" : null}}>8. ¿Toma medicación para la hipertensión regularmente?</div>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ1Answers">
                                <div className={HipertensionMeds === 0 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q3"] === "invalid" ? "red solid 1px" : HipertensionMeds.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: HipertensionMeds === 0 ? "#F2F2FF" : validation2["Q3"] === "invalid" ? "#FFFAEA" : "white"}} id="HipertensionMedsTile" onClick={() => setHipertensionMeds(0)}>
                                    Si 
                                </div>
                                <div className={HipertensionMeds === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q3"] === "invalid" ? "red solid 1px" : HipertensionMeds.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: HipertensionMeds === 1 ? "#F2F2FF" : validation2["Q3"] === "invalid" ? "#FFFAEA" : "white"}} id="NoHipertensionMedsTile" onClick={() => setHipertensionMeds(1)}>
                                    No
                                </div>
                            </div>
                        </div>
                        {validation2["Q3"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja una opción en la pregunta anterior</div>
                        : null }
                    </div>
                    <div className='DiabetesRiskCalculatorRightSideSurveyQ1'>
                        <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className="UserWelcomeBlockYNQuestion DiabetesRiskCalculatorRightSideSurveyPart2Question" style={{color: validation2["Q4"] === "invalid" ? "red" : Hyperglycemia.length !== 0 ? "#8BC53F" : null}}>9. ¿Le han encontrado alguna vez valores de glicemia altos?</div>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ1Answers">
                                <div className={Hyperglycemia === 0 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q4"] === "invalid" ? "red solid 1px" : Hyperglycemia.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Hyperglycemia === 0 ? "#F2F2FF" : validation2["Q4"] === "invalid" ? "#FFFAEA" : "white"}} id="HyperglycemiaTile" onClick={() => setHyperglycemia(0)}>
                                    Si 
                                </div>
                                <div className={Hyperglycemia === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q4"] === "invalid" ? "red solid 1px" : Hyperglycemia.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: Hyperglycemia === 1 ? "#F2F2FF" : validation2["Q4"] === "invalid" ? "#FFFAEA" : "white"}} id="NoHyperglycemiaTile" onClick={() => setHyperglycemia(1)}>
                                    No
                                </div>
                            </div>
                        </div>
                        {validation2["Q4"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja una opción en la pregunta anterior</div>
                        : null }
                    </div>
                    <div className='DiabetesRiskCalculatorRightSideSurveyQ1'>
                        <div className="DiabetesRiskCalculatorRightSideSurveyQ1TileFlex">
                            <div className="UserWelcomeBlockYNQuestion DiabetesRiskCalculatorRightSideSurveyPart2Question" style={{color: validation2["Q5"] === "invalid" || validation2["Tiles"] === "invalid" ? "red" : FamilyMember.length !== 0 ? "#8BC53F" : null}}>10. ¿Algún familiar está diagnosticado de diabetes (tipo I o II)?</div>
                            <div className="DiabetesRiskCalculatorRightSideSurveyQ1Answers">
                                <div className={FamilyMember === 1 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q5"] === "invalid" ? "red solid 1px" : FamilyMember.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: FamilyMember === 1 ? "#F2F2FF" : validation2["Q5"] === "invalid" ? "#FFFAEA" : "white"}} id="FamilyMemberTile" onClick={() => FamilyMemberChange("YES")}>
                                    Si 
                                </div>
                                <div className={FamilyMember === 0 ? "DiabetesRiskCalculatorRightSideSurveyQ1Tile DiabetesRiskCalculatorRightSideSurveyQ1ActiveTile" : "DiabetesRiskCalculatorRightSideSurveyQ1Tile"} style={{borderBottom: validation2["Q5"] === "invalid" ? "red solid 1px" : FamilyMember.length !== 0 ? "#8BC53F solid 1px" : "#BFD4E4 solid 1px", backgroundColor: FamilyMember === 0 ? "#F2F2FF" : validation2["Q5"] === "invalid" ? "#FFFAEA" : "white"}} id="NoFamilyMemberTile" onClick={() => FamilyMemberChange("NO")}>
                                    No
                                </div>
                            </div>
                        </div>
                        {FamilyMember?
                            <div className='DiabetesRiskCalculatorPart2FamilyFlex'>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="ParentsTile" onClick={() => ParentsChange()}>Padres</div>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="SiblingsTile" onClick={() => SiblingsChange()}>Hermanos</div>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="ChildrenTile" onClick={() => ChildrenChange()}>Hijos</div>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="GrandparentsTile" onClick={() => GrandparentsChange()}>Abuelos</div>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="UnclesAndAuntsTile" onClick={() => UnclesAndAuntsChange()}>Tios</div>
                                <div className='DiabetesRiskCalculatorPart2FamilyMember' id="CousinsTile" onClick={() => CousinsChange()}>Primos</div>
                            </div>
                        : null}
                        {validation2["Q5"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja una opción en la pregunta anterior</div>
                        : validation2["Tiles"] === "invalid" ?
                            <div className='YNAlert' style={{ color: "red", fontWeight: "500" }}> Escoja las opciones que indiquen cuál/es de sus familiares tienen diabetes </div>
                        : null }
                    </div>
                </div>
            </div>
            </div>
            <div className='UserWelcomeBlockNextButtonFlex'>
                <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {GoBack(); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                    <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                    <div className="GeneralWhiteButtonText GeneralWhiteButtonTextPreviousText">Anterior</div>
                </div>
                <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => CalculateDiabetesRisk()}>
                    <div className="GeneralPurpleButtonText">Calcular</div>
                    <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                </div>
            </div>
          </>
          : Calculated ?
          <>
          <div className="HeartAgeCalculatorResultsTitleDiv UserProfileHeartAgeCalculatorWhiteBlockTitleDiv" style={{backgroundColor:"#CCCCFF"}}>
            <div className="HeartAgeCalculatorRightSideTitleFlex">
              <img alt="" className="HeartAgeCalculatorRightSideTitleIcon" src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleLogo.png"/>
              <div className="HeartAgeCalculatorRightSideTitleInnerDiv">
                <div className="HeartAgeCalculatorRightSideUpTitle">Calculadora de Salud</div>
                <div className="HeartAgeCalculatorRightSideTitle">Resultados</div>
                <div className="HeartAgeCalculatorRightSideUpTitle">Test Findrisk</div>
              </div>
            </div>
            <img alt="" className="HeartAgeCalculatorResultsTitleYMCLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_NoText.png"/>
          </div>
          <div className='DiabetesRiskCalculatorResults'>
                <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideR'>
                        <div className="UserProfileDiabetesWhiteBoxPart2">
                            <h5 className='DiabetesRiskCalculatorResults2Title' style={{textAlign:"center", maxWidth:"700px"}}>¿Qué riesgo tiene usted de desarrollar diabetes tipo 2?</h5>
                            {RiskPoints < 12 ?
                                <>
                                    <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockFlex'>
                                        <img alt="" className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockMainImage' src="https://static.yomecontrolo.cl/public/img/packs/DM00YMC020.png" />
                                        <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock' style={{ backgroundColor:"#8BC53F"}}>
                                            <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1'>Riesgo {RiskCategory}</div> 
                                            <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3'>{RiskPoints}/26 puntos</div> 
                                        </div>
                                    </div>
                                    <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                        <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeterFace3" style={{ left: "-5px", backgroundColor:"#8BC53F", color:"#FBFFFF" }} >1%</div>
                                    </div>
                                    <div className="DiabetesResultSubtext HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1">
                                        En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Sin embargo, su riesgo cambia a lo largo del tiempo y aumenta con la edad.<br/><br/>
                                        Hoy 2,5 millones de chilenos sufren esta patología. Estudios nacionales han reportado que más de la mitad de los pacientes diabéticos son muchas veces diagnosticados tarde, es decir, cuando ya presentaban síntomas de que la enfermedad se había desarrollado. Asegúrate de realizar tus exámenes preventivos regularmente y mantener hábitos de vida saludables para prevenir o retrasar el desarrollo de enfermedades como la diabetes y la enfermedad renal crónica.
                                        <br/> 
                                        <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",1)}>Leer menos...</span>
                                    </div>
                                    <div className="DiabetesResultSubtext" id="More1">
                                        En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Sin embargo, su riesgo cambia a lo largo del tiempo y aumenta con la edad.
                                        <br/><br/>
                                        <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",1)}>Leer más...</span>
                                    </div>
                                    {/*
                                    <div className='DiabetesResultMedicalOrderContainer' style={{paddingInline:"2%"}}>
                                        <div className='GeneralPurpleButtonFlex DiabetesResultMedicalOrder' onClick={() => getRecommendedExams()}>
                                            Generar Órden Médica Personalizada
                                        </div>
                                    </div>*/}
                                </>
                            : RiskPoints >= 12 && RiskPoints <=14 ? 
                                <>
                                <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockFlex'>
                                    <img alt="" className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockMainImage' src="https://static.yomecontrolo.cl/public/img/packs/DM00YMC020.png" />
                                    <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock' style={{ backgroundColor:"#FFCD29"}}>
                                        <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1'>Riesgo {RiskCategory}</div> 
                                        <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3'>{RiskPoints}26 puntos</div> 
                                    </div>
                                </div>
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                    <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeterFace3" style={{ left: "-3px", right: "0", margin: "0 auto", backgroundColor:"#FFCD29" }} >17%</div>
                                </div>
                                <div className="DiabetesResultSubtext HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1">
                                    En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Esto significa que de cada 100 personas con el mismo puntaje, 17 desarrollarán diabetes en un plazo de 10 años, tú podrías ser una de ellas.<br/><br/>
                                    Las intervenciones para prevenir o retrasar la diabetes tipo 2 en personas con prediabetes son factibles y económicas. En diversos estudios se ha determinado que las intervenciones de estilo de vida son más económicas que los medicamentos.<br/><br/>
                                    La falta de diagnóstico oportuno es una importante causa de desarrollo prematuro de las formas más severas de DM2. Se ha demostrado que el manejo temprano de pacientes con DM2 retrasa y reduce la incidencia de complicaciones derivadas de la enfermedad.<br/><br/>
                                    Hoy 2,5 millones de chilenos sufren esta patología. Estudios nacionales han reportado que más de la mitad de los pacientes diabéticos son muchas veces diagnosticados tarde, es decir, cuando ya presentaban síntomas de que la enfermedad se había desarrollado.  Asegúrate de realizar tus exámenes preventivos regularmente y mantener hábitos de vida saludables para prevenir o retrasar el desarrollo de enfermedades como la diabetes y la enfermedad renal crónica.
                                    <br/> 
                                    <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",1)}>Leer menos...</span>
                                </div>
                                <div className="DiabetesResultSubtext" id="More1">
                                    En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Esto significa que de cada 100 personas con el mismo puntaje, 17 desarrollarán diabetes en un plazo de 10 años, tú podrías ser una de ellas.<br/><br/>
                                    Las intervenciones para prevenir o retrasar la diabetes tipo 2 en personas con prediabetes son factibles y económicas. En diversos estudios se ha determinado que las intervenciones de estilo de vida son más económicas que los medicamentos.
                                    <br/><br/>
                                    <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",1)}>Leer más...</span>
                                </div>
                                {/*
                                <div className='DiabetesResultMedicalOrderContainer' style={{paddingInline:"2%"}}>
                                    <div className='GeneralPurpleButtonFlex DiabetesResultMedicalOrder' onClick={() => getRecommendedExams()}>
                                        Generar Órden Médica Personalizada
                                    </div>
                                </div>*/}
                                </>
                            : RiskPoints > 14 ?
                            <>
                            <h2 className='DiabetesRiskCalculatorResultsTitlePart2 DiabetesRiskCalculatorResultsTextPadding'>Existe un alto riesgo de diabetes en tu vida</h2>
                            <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockFlex'>
                                <img alt="" className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockMainImage' src="https://static.yomecontrolo.cl/public/img/packs/DM00YMC020.png" />
                                <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock' style={{ backgroundColor:"#FF4F53", color:"white"}}>
                                    <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText1'>Riesgo {RiskCategory}</div> 
                                    <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockText3'>{RiskPoints}/26 puntos</div> 
                                </div>
                            </div>
                            <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'left',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                                <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeterFace3" style={{ right: "-5px", backgroundColor:"#FF4F53", color:"#FBFFFF"}} >{RiskPoints < 20 ? 33 : 50}%</div>
                            </div>
                            <div className="DiabetesResultSubtext HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1">
                                En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Esto significa que de cada 100 personas con el mismo puntaje, {RiskPoints < 20 ? 33 : 50} desarrollarán diabetes en un plazo de 10 años, tú podrías ser una de ellas.<br/><br/>
                                Te recomendamos realizar realizar tu chequeo preventivo anual y acudir a tu médico de cabecera para comenzar un plan de mitigación de factores de riesgos cardiometabólicos intensivo.<br/><br/>
                                El Programa de Prevención de la Diabetes (DPP), un estudio amplio de prevención en personas con un riesgo alto de diabetes demostró que las intervenciones en el estilo de vida para perder peso y aumentar la actividad física redujeron la aparición de la diabetes tipo 2 en un 58% durante un periodo de 3 años. La reducción fue aún mayor (71%) en los adultos de 60 años o más.<br/><br/>
                                La diabetes puede provocar graves complicaciones y muerte prematura, pero las personas con esta enfermedad, en conjunto con su red de apoyo y proveedores de atención médica, pueden tomar algunas medidas para controlar la enfermedad y disminuir el riesgo de complicaciones.<br/><br/>
                                Pero, cuando es muy elevada la glicemia la persona puede padecer de:<br/>
                                Mucha sed.<br/>
                                Orinar muy seguido incluso en la noche.<br/>
                                Bajar de peso.<br/>
                                Tener mucha hambre, "ya en esa etapa tardía la diabetes está descompensada”.
                                <br/> 
                                <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More",1)}>Leer menos...</span>
                            </div>
                            <div className="DiabetesResultSubtext" id="More1">
                                En este momento su riesgo de tener diabetes tipo 2 en un plazo de 10 años es {RiskCategory}. Esto significa que de cada 100 personas con el mismo puntaje, {RiskPoints < 20 ? 33 : 50} desarrollarán diabetes en un plazo de 10 años, tú podrías ser una de ellas.<br/><br/>
                                Te recomendamos realizar realizar tu chequeo preventivo anual y acudir a tu médico de cabecera para comenzar un plan de mitigación de factores de riesgos cardiometabólicos intensivo.
                                <br/><br/>
                                <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less",1)}>Leer más...</span>
                            </div>
                            {/*
                            <div className='DiabetesResultMedicalOrderContainer' style={{paddingInline:"2%"}}>
                                <div className='GeneralPurpleButtonFlex DiabetesResultMedicalOrder' onClick={() => getRecommendedExams()}>
                                    Generar Órden Médica Personalizada
                                </div>
                            </div>*/}
                            </>
                            : null
                            }
                        </div>
                    </div>
                    <div className='UserWelcomeBlockPageWideSideL'>
                        <div className="UserProfileDiabetesWhiteBoxPart3">
                            <div className="DiabetesRiskCalculatorResultsTextPadding">
                                <h5 className="HeartAgeCalculatorLeftSideResultPartName">Antecedentes del cálculo</h5>
                                <h2 className="HeartAgeCalculatorLeftSideResultTitle">Condiciones de Uso de la Calculadora de Salud</h2>
                            </div>
                            <div className="DiabetesRiskCalculatorLeftSideSubtitleEnd" id="More">¿A quienes está dirigida esta herramienta? 
                                <br/>
                                El test de FINDRISC está dirigido especialmente a las personas que presentan 2 o más factores de riesgo de diabetes mellitus, Tales como:
                                    <ul>
                                        <li>Personas que presenten sobrepeso u obesidad.</li>
                                        <li>Mayores de 45 años de edad.</li>
                                        <li>Antecedentes personales de niveles elevados de glucosa en sangre.</li>
                                        <li>Antecedentes familiares de diabetes.</li>
                                        <li>Personas sedentarias.</li>
                                        <li>Mujeres con antecedente de diabetes gestacional o síndrome de ovario poliquístico.</li>
                                        
                                    </ul>
                            <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("Less")}>Leer más...</span></div>
                            <div className="DiabetesRiskCalculatorLeftSideSubtitleEnd HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less">
                                <b>¿A quienes está dirigida esta herramienta?</b>
                                <br/>
                                El test de FINDRISC está dirigido especialmente a las personas que presentan 2 o más factores de riesgo de diabetes mellitus, Tales como:
                                    <ul>
                                        <li>Personas que presenten sobrepeso u obesidad.</li>
                                        <li>Mayores de 45 años de edad.</li>
                                        <li>Antecedentes personales de niveles elevados de glucosa en sangre.</li>
                                        <li>Antecedentes familiares de diabetes.</li>
                                        <li>Personas sedentarias.</li>
                                        <li>Mujeres con antecedente de diabetes gestacional o síndrome de ovario poliquístico.</li>
                                        
                                    </ul> 
                                <br/>
                                La escala FINDRISC es un instrumento de cribaje inicialmente diseñado para valorar el riesgo individual de desarrollar DM2 en el plazo de 10 años. Las principales variables que se relacionan con el riesgo de desarrollar DM en esta escala son: edad, IMC, el perímetro de la cintura, hipertensión arterial con tratamiento farmacológico y los antecedentes personales de glucemia elevada.
                                <br/><br/>
                                Pese a que en esta herramienta no ha sido validad en población chilena, su uso se encuentra  aprobada por la Federación Internacional de Diabetes (FID) y es utilizado en países como EE.UU., España, Grecia, Italia y Colombia  entre otros, para la identificación de personas con mayor riesgo de desarrollar diabetes tipo 2.
                                <br/>
                                <span className='HeartAgeCalculatorResultsRightSideWhatIfConsequenceTextOption' onClick={() => toggleDescription("More")}>Leer menos...</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='GeneralWhiteButtonFlex UserWelcomeBlockPageButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud");}}>Terminar</div>
                    <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion");}}>Ir a Recomendaciones</div>
                </div>
            </div>
            </>
            : null}
          </div>
        </div>
      </div>
    );
};

export default DiabetesCalculator;